export * from './gs-area-wysiwyg.component';
